"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var technician_service_1 = require("../../../shared/service/technician.service");
var technician_1 = require("../../../shared/model/technician");
var auto_eletric_service_1 = require("../../../shared/service/auto-eletric.service");
var auto_eletric_provided_service_service_1 = require("../../../shared/service/auto-eletric-provided-service.service");
var cpf_pipe_1 = require("../../../shared/pipe/cpf.pipe");
var phone_pipe_1 = require("../../../shared/pipe/phone.pipe");
var save_http_error_1 = require("../../../shared/error/save-http-error");
var update_http_error_1 = require("../../../shared/error/update-http-error");
var vehicle_1 = require("../../../shared/model/vehicle");
var toast_service_1 = require("../../../shared/service/toast.service");
var TechnicianCreateUpdateComponent = /** @class */ (function () {
    function TechnicianCreateUpdateComponent(_route, _router, _technicianService, _autoEletricService, _autoEletricServiceService, _toastService) {
        this._route = _route;
        this._router = _router;
        this._technicianService = _technicianService;
        this._autoEletricService = _autoEletricService;
        this._autoEletricServiceService = _autoEletricServiceService;
        this._toastService = _toastService;
        this.autoEletricAttributesTree = ['name'];
        this.providedServicesAttributesTree = ['providedService', 'name'];
        this.providedServicesComparableAttribute = ['providedService', 'id'];
        this.editMode = false;
        this.setUpObjects();
        this.editModeVerify();
        this.setPipes();
        this.setUpObservers();
    }
    TechnicianCreateUpdateComponent.prototype.ngOnInit = function () { };
    TechnicianCreateUpdateComponent.prototype.ngAfterViewChecked = function () {
        try {
            Materialize.updateTextFields();
        }
        catch (e) { }
    };
    TechnicianCreateUpdateComponent.prototype.save = function () {
        if (this.editMode) {
            this._technicianService.update(this.newTechnician);
        }
        else {
            this._technicianService.save(this.newTechnician);
        }
    };
    TechnicianCreateUpdateComponent.prototype.editModeVerify = function () {
        var _this = this;
        this.partialTitle = 'Cadastrar ';
        this._route.params.subscribe(function (params) {
            if (params['id']) {
                _this.editMode = true;
                _this.technicianId = +params['id'];
                _this._technicianService.findById(_this.technicianId);
                _this.partialTitle = 'Editar ';
            }
        });
    };
    TechnicianCreateUpdateComponent.prototype.updateSelectedProvidedServices = function (services) {
        this.newTechnician.autoEletricServices = services;
    };
    TechnicianCreateUpdateComponent.prototype.checkProvidedService = function (item) {
        var isChecked = false;
        if (this.newTechnician.autoEletricServices) {
            this.newTechnician.autoEletricServices.forEach(function (service) {
                if (service.id === item.id) {
                    isChecked = true;
                }
            });
        }
        return isChecked;
    };
    TechnicianCreateUpdateComponent.prototype.addOrRemoveFromTechnicianServices = function (service) {
        var wasSelected = false;
        if (this.newTechnician.autoEletricServices) {
            this.newTechnician.autoEletricServices.forEach(function (selectedOption, index, array) {
                if (selectedOption.id === service.id) {
                    array.splice(index, 1);
                    wasSelected = true;
                }
            });
        }
        if (!wasSelected) {
            this.newTechnician.autoEletricServices.push(service);
        }
    };
    TechnicianCreateUpdateComponent.prototype.findAutoEletricsByName = function (name) {
        this._autoEletricService.findByName(name);
    };
    TechnicianCreateUpdateComponent.prototype.findAutoEletricService = function (autoEletric) {
        this.newTechnician.autoEletric = autoEletric;
        this._autoEletricServiceService.findListByAutoEletricId(autoEletric.id);
    };
    TechnicianCreateUpdateComponent.prototype.setPipes = function () {
        this.cpfPipe = new cpf_pipe_1.CpfPipe();
        this.phonePipe = new phone_pipe_1.PhonePipe();
    };
    TechnicianCreateUpdateComponent.prototype.applyCpfMask = function (event) {
        return this.cpfPipe.transform(event.target.value, event.key);
    };
    TechnicianCreateUpdateComponent.prototype.applyPhoneMask = function (event) {
        return this.phonePipe.transform(event.target.value, event.key);
    };
    TechnicianCreateUpdateComponent.prototype.goBack = function () {
        this._router.navigate(['technicians/list']);
    };
    TechnicianCreateUpdateComponent.prototype.setUpObjects = function () {
        this.newTechnician = new technician_1.Technician();
        this.newTechnician.vehicle = new vehicle_1.Vehicle();
        this.newTechnician.autoEletricServices = new Array();
        this.newTechnician.argosUser = {};
        this.autoEletrics = new Array();
    };
    TechnicianCreateUpdateComponent.prototype.setUpObservers = function () {
        if (this.editMode) {
            this.setUpSaveUpdateAction(this._technicianService.update$);
        }
        else {
            this.setUpSaveUpdateAction(this._technicianService.save$);
        }
        this.setUpFindAction(this._technicianService.find$);
        this.setUpErrorAction(this._technicianService.error$);
        this.setUpFindAutoEletrics(this._autoEletricService.find$);
        this.setUpFindAutoEletricServices(this._autoEletricServiceService.find$);
    };
    TechnicianCreateUpdateComponent.prototype.setUpSaveUpdateAction = function (observable) {
        var _this = this;
        observable
            .subscribe(function () {
            _this.goBack();
        });
    };
    TechnicianCreateUpdateComponent.prototype.setUpFindAction = function (observable) {
        var _this = this;
        observable
            .filter(function (technician) { return technician instanceof technician_1.Technician; })
            .subscribe(function (technician) {
            _this.newTechnician = technician;
            _this.newTechnician.argosUser = technician.argosUser || {};
            _this.autoEletrics = new Array();
            _this.newTechnician.vehicle = technician.vehicle || {};
            _this.autoEletrics.push(_this.newTechnician.autoEletric);
            _this.findAutoEletricService(_this.newTechnician.autoEletric);
        });
    };
    TechnicianCreateUpdateComponent.prototype.setUpErrorAction = function (observable) {
        var _this = this;
        observable
            .filter(function (error) { return error instanceof save_http_error_1.SaveHttpError || error instanceof update_http_error_1.UpdateHttpError; })
            .subscribe(function (error) {
            _this.newTechnician.vehicle = _this.newTechnician.vehicle || new vehicle_1.Vehicle();
            _this._toastService.showMessage(error.text, 4000);
        });
    };
    TechnicianCreateUpdateComponent.prototype.setUpFindAutoEletrics = function (observable) {
        var _this = this;
        observable
            .filter(function (autoEletrics) { return autoEletrics instanceof Array; })
            .subscribe(function (autoEletrics) { return _this.autoEletrics = autoEletrics; });
    };
    TechnicianCreateUpdateComponent.prototype.setUpFindAutoEletricServices = function (observable) {
        var _this = this;
        observable
            .filter(function (autoEletricProvidedServices) { return autoEletricProvidedServices instanceof Array; })
            .subscribe(function (autoEletricProvidedServices) {
            _this.autoEletricProvidedServices = autoEletricProvidedServices;
        });
    };
    TechnicianCreateUpdateComponent.ctorParameters = function () { return [{ type: router_1.ActivatedRoute }, { type: router_1.Router }, { type: technician_service_1.TechnicianService }, { type: auto_eletric_service_1.AutoEletricService }, { type: auto_eletric_provided_service_service_1.AutoEletricProvidedServiceService }, { type: toast_service_1.ToastService }]; };
    return TechnicianCreateUpdateComponent;
}());
exports.TechnicianCreateUpdateComponent = TechnicianCreateUpdateComponent;
//# sourceMappingURL=technician-create-update.component.js.map


// WEBPACK FOOTER //
// technician-create-update.component.js